/* eslint-disable no-unused-vars */
import axios from "axios"

export const fetchFuels = async ({ queryKey }) => {
  // eslint-disable-next-line no-unused-vars, no-debugger
  const [_, param] = queryKey
  const result = await axios.post(`/api/Accounting/GetFuel`, param)
  return result.data
}

export const importFuel = async file => {
  const result = await axios.post(`/api/Accounting/ImportFuel/`, file)
  return result.data
}

export const deleteFuel = async fuelId => {
  const result = await axios.delete(
    `/api/Accounting/DeleteFuelByID?fuelId=${fuelId}`
  )
  return result.data
}

export const importFuelToExpense = async data => {
  const result = await axios.post(`/api/Expense/ImportFuelExpense/`, data)
  return result.data
}
